import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

type HubSponsoredContentArticlesProps = {
  /** The card props to be displayed in the component. */
  cardProps: ComponentProps<typeof Card>[];
  /** The class name to be applied to the component. */
  className?: string;
};

const HubSponsoredContentArticles = ({
  cardProps,
  className,
}: HubSponsoredContentArticlesProps): React.ReactElement => {
  if (cardProps.length === 0) return <></>;

  const variant: CardVariations = {
    image: { position: "", width: "w-full" },
    content: { width: "w-full", extraClass: "pt-3" },
    kicker: {
      color: "text-gray-550",
      extraClass: cn("font-poppins text-4xs font-light leading-5"),
    },
    title: {
      size: "text-base",
      color: "text-gray-850",
      extraClass: cn("font-bold font-lct my-1"),
    },
  };

  return (
    <div
      className={className}
      data-testid="hub-sponsored-content-articles-component"
    >
      <div
        className={cn(
          "stories grid divide-y divide-gray-175",
          "md:grid-cols-2 md:gap-4 md:divide-y-0"
        )}
      >
        {cardProps.map((cardProps) => {
          return (
            <Card
              key={cardProps.id}
              {...cardProps}
              className={cn("story flex-col pb-2 pt-4", "md:p-0")}
              variations={variant}
            />
          );
        })}
      </div>
    </div>
  );
};

export default HubSponsoredContentArticles;
